export const initialState = {
  admin: {},
  events: {},
  global: {
    theme: 'default'
  },
  queues: {},
  session: {}
}
